import styled, { css, keyframes } from 'styled-components'

const countdownShrink = keyframes`
  from { --countdown-progress: 1 }
  to   { --countdown-progress: 0 }
`

export const ModalContent = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    padding: ${theme.space['16']};
    max-width: 50rem;
    width: 100%;
    outline: none;
    background-color: ${theme.colors.white};
    border-radius: ${theme.border.radius['4']};
    box-shadow: ${theme.shadow.xl};
  `,
)

export const Title = styled.h2(
  ({ theme }) => css`
    font-size: 2.4rem;
    font-weight: 500;
    line-height: 3.2rem;
    color: ${theme.colors.black700};
    text-align: center;
    margin: ${theme.space['0']} ${theme.space['0']} ${theme.space['8']};
  `,
)

export const SubTitle = styled.p(
  ({ theme }) => css`
    font-size: 1.6rem;
    font-weight: 400;
    line-height: 2.4rem;
    color: ${theme.colors.black500};
    text-align: center;
    margin: ${theme.space['0']} ${theme.space['0']} ${theme.space['20']};
  `,
)

export const CountdownContainer = styled.div<{ $delay: number }>(
  ({ theme, $delay }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    align-self: center;
    aspect-ratio: 1 / 1;
    width: 16rem;
    border-radius: ${theme.border.radius.circle};
    margin: ${theme.space['0']} ${theme.space['0']} ${theme.space['20']};
    background:
      radial-gradient(closest-side, white 95%, transparent 80% 100%),
      conic-gradient(
        ${theme.colors.marketShopBrand800} calc(var(--countdown-progress) * 100%),
        ${theme.colors.gray400} 0
      );
    animation: ${countdownShrink} ${$delay}ms linear forwards;

    > span:first-child {
      font-size: 4.8rem;
      font-weight: 700;
      line-height: 4.8rem;
      color: ${theme.colors.black700};
    }

    > span:last-child {
      font-size: 1.8rem;
      line-height: 1.8rem;
      color: ${theme.colors.black500};
    }
  `,
)
